<div class="flex flex-col w-full bg-white dark:bg-gray-900 pb-6 md:pb-10">
    <div class="relative flex flex-col flex-auto items-center w-full">
        <!-- Header y Rutina Panel fuera del contenedor paddings -->
        <div class="w-full sticky top-0 z-30 bg-white dark:bg-gray-900 pt-2 md:pt-5 pb-2 md:pb-4 px-2 md:px-6 header-shadow-transition"
            [class.scrolled]="headerScrolled">
            <div class="flex items-center justify-between w-full px-2">
                <h3 class="text-lg md:text-3xl font-bold dark:text-gray-100 mb-1 md:mb-2">Detonador de rutinas</h3>
                <div class="justify-end transition-all duration-300" [class.opacity-0]="isLoading"
                    [class.translate-y-0]="!isLoading">
                    <button
                        class="h-9 md:h-12 w-9 md:w-12 rounded-full shadow-md bg-green-500 text-white flex items-center justify-center hover:scale-110 transition-all duration-300"
                        (click)="sendRoutineToWS(true)" [disabled]="!someRoutineIsReady()">
                        <mat-icon style="color: white;">play_arrow</mat-icon>
                    </button>
                </div>
            </div>
        </div>
        <div class="w-full flex flex-col flex-auto px-2 md:px-30 lg:px-40 xl:px-44 2xl:px-120">
            @if (isLoading) {
            <div class="flex items-center justify-center pt-32">
                <mat-spinner></mat-spinner>
            </div>
            }
            <div class="flex flex-col px-2 sm:px-6 transition-all duration-500 opacity-0 translate-y-4"
                [class.opacity-100]="!isLoading" [class.translate-y-0]="!isLoading">
                @for (routineSel of selectedRoutines; let routineIndex = $index; track $index) {
                @if (routineSel.id == null) {
                <!-- Botón para agregar rutina -->
                <div class="w-full max-w-7xl mx-auto mb-8">
                    <div
                        class="flex flex-col items-center justify-center p-12 bg-white dark:bg-gray-800 border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-xl">
                        <mat-icon class="text-6xl text-gray-400 dark:text-gray-500 mb-4">add_circle_outline</mat-icon>
                        <h4 class="text-xl font-semibold mb-2 dark:text-gray-100">Agregar rutina</h4>
                        <p class="text-gray-600 dark:text-gray-400 mb-6 text-center">
                            Haz clic en el botón para seleccionar una rutina de la lista
                        </p>
                        <button mat-raised-button color="primary" (click)="openRoutineSelectionModal()"
                            class="!bg-blue-600 !text-white hover:!bg-blue-700 !px-8 !py-3">
                            <mat-icon class="mr-2">add</mat-icon>
                            Seleccionar rutina
                        </button>
                    </div>
                </div>
                }

                @else {
                <!-- <mat-expansion-panel [expanded]="true" class="border-2 border-green-400"> -->
                <mat-expansion-panel class="dark:bg-gray-800 mb-6 md:mb-10 rounded-xl" [expanded]="true" hideToggle>
                    <mat-expansion-panel-header class="h-auto bg-cyan-900"
                        [class.border-2]="getRoutineStatusColor(routineSel) !== 'default'"
                        [class.border-green-400]="getRoutineStatusColor(routineSel) === 'green'"
                        [class.border-yellow-400]="getRoutineStatusColor(routineSel) === 'yellow'"
                        [class.border-b-2]="getRoutineStatusColor(routineSel) === 'default'"
                        [class.border-gray-400]="getRoutineStatusColor(routineSel) === 'default'">
                        <div class="flex flex-col w-full my-3">
                            <div class="flex items-center justify-between w-full mb-3">
                                <div class="flex items-center gap-3">
                                    <div class="flex flex-col">
                                        <div class="font-bold text-md md:text-lg text-white">Rutina: {{ routineSel.name
                                            }}</div>
                                        <div class="text-sm text-white text-opacity-80">{{
                                            getRoutineType(routineSel.routine_type_id) }}</div>
                                    </div>
                                </div>

                                <button mat-icon-button
                                    class="w-8 h-8 rounded-full transition-all"
                                    [class.bg-red-500]="!disableTrashButton(routineSel)"
                                    [class.hover:bg-red-600]="!disableTrashButton(routineSel)"
                                    [class.bg-gray-400]="disableTrashButton(routineSel)"
                                    [class.cursor-not-allowed]="disableTrashButton(routineSel)"
                                    [class.opacity-50]="disableTrashButton(routineSel)"
                                    (click)="removeRoutine($index)" (click)="$event.stopPropagation()" [disabled]="disableTrashButton(routineSel)">
                                    <mat-icon class="text-white text-lg">delete</mat-icon>
                                </button>
                            </div>

                            <!-- Player info y botón de play -->
                            <div class="flex items-center justify-between gap-4">
                                <!-- Player info sin contenedor extra -->
                                <div *ngIf="!routineSel.selected_user_id; else playerCard"
                                    class="flex items-center gap-3 cursor-pointer"
                                    (click)="openPlayerSelectionModal($event, routineIndex)">
                                    <div
                                        class="w-7 h-7 bg-white bg-opacity-20 rounded-full flex items-center justify-center">
                                        <mat-icon class="text-white text-sm">person_add</mat-icon>
                                    </div>
                                    <div class="flex flex-col">
                                        <span class="text-white font-semibold text-sm">Seleccionar jugador</span>
                                        <span class="text-white text-opacity-70 text-xs">Jugador</span>
                                    </div>
                                </div>

                                <ng-template #playerCard>
                                    <div class="rounded-full pr-3 py-2 flex items-center gap-3 cursor-pointer hover:bg-opacity-40 transition-all"
                                        (click)="openPlayerSelectionModal($event, routineIndex)">
                                        <div
                                            class="w-7 h-7 bg-black bg-opacity-40 rounded-full flex items-center justify-center">
                                            <span class="text-white text-sm font-bold">
                                                {{ getPlayerInitials(routineSel.selected_user_id) }}
                                            </span>
                                        </div>
                                        <div class="flex flex-col">
                                            <span class="text-white font-semibold text-sm">
                                                {{ getPlayerNameById(routineSel.selected_user_id) }}
                                            </span>
                                            <span class="text-white text-opacity-70 text-xs">Jugador</span>
                                        </div>
                                    </div>
                                </ng-template>

                                @if (!routineSel.routine_log_id) {
                                <button type="button"
                                    class="h-8 w-8 rounded-full shadow-md bg-cyan-700 text-white flex items-center justify-center transition-all duration-300 hover:bg-cyan-800"
                                    [disabled]="getRoutineStatusColor(routineSel) !== 'green'"
                                    matTooltip="Iniciar solo esta rutina"
                                    (click)="sendRoutineToWS(false, routineIndex, $event)">
                                    <mat-icon style="color: white;">play_arrow</mat-icon>
                                </button>
                                }
                                @else{
                                <button type="button"
                                    class="h-8 w-8 rounded-full shadow-md bg-cyan-700 text-white flex items-center justify-center transition-all duration-300 hover:bg-cyan-800"
                                    [disabled]="getRoutineStatusColor(routineSel) !== 'green'"
                                    matTooltip="Iniciar solo esta rutina"
                                    (click)="stopRoutine($event, routineSel.routine_log_id)">
                                    <mat-icon style="color: white;">stop</mat-icon>
                                </button>
                                }

                            </div>
                        </div>
                    </mat-expansion-panel-header>
                    <div class="mt-2 md:mt-4">
                        <div class="w-full overflow-x-auto">
                            <app-field-grid class="w-[340px] sm:w-[480px] md:w-[600px] lg:w-1/2 mx-auto" [src]="src"
                                [alt]="alt" [numCols]="numCols" [typesDevices]="routineSel.typesDevices"
                                [tableData]="routineSel.table_data" [status]="2" [isRoutine]="true"
                                [routine]="routineSel" [allDevices]="devices" [devicesStatus]="devicesStatus"
                                (cellClick)="onCellClick(routineIndex, $event)"
                                (cellRightClick)="onCellRightClick(routineIndex, $event)"
                                (cellLongPress)="onCellLongPress(routineIndex, $event)">
                            </app-field-grid>
                        </div>
                    </div>
                </mat-expansion-panel>
                }
                }
            </div>
        </div>
    </div>
</div>

<ng-template #playerModal>
    <h2 mat-dialog-title class="text-lg sm:text-xl font-semibold dark:text-gray-100">{{ getPlayerModalTitle() }}</h2>

    <mat-dialog-content class="p-0 mt-2 space-y-4">
        <div *ngIf="hasCamera" class="px-4">
            <div class="mt-4">
                <mat-slide-toggle [color]="'primary'" [(ngModel)]="needUseSelectPlayer">Usar seleccion
                    manual</mat-slide-toggle>
            </div>
        </div>

        @if (hasCamera && !needUseSelectPlayer) {
        <!-- Escáner QR activo -->
        <div *ngIf="isScanning"
            class="w-full aspect-video rounded overflow-hidden shadow border border-gray-200 dark:border-gray-700 relative">
            <zxing-scanner [formats]="['QR_CODE']" (scanSuccess)="onCodeResult($event)"
                style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; object-fit: cover;">
            </zxing-scanner>
        </div>
        <div *ngIf="isProcessing" class="w-full mt-4 text-center text-blue-600">
            <mat-progress-spinner diameter="30" mode="indeterminate" color="primary"></mat-progress-spinner>
            <span class="font-medium">Procesando escaneo...</span>
        </div>
        }
        @else {
        <!-- Selector manual -->
        <mat-form-field appearance="fill" class="w-full lg:w-1/2 mt-4">
            <mat-label>Jugador</mat-label>
            <mat-select (selectionChange)="onPlayerSelect($event.value)">
                <mat-option *ngFor="let player of getAvailablePlayers()" [value]="player.uuid">
                    {{ player.name }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        }
    </mat-dialog-content>

    <mat-dialog-actions align="end" class="mt-4">
        <button type="button" mat-raised-button color="warn" (click)="closeModal()">
            Cancelar
        </button>
    </mat-dialog-actions>
</ng-template>
